module.exports = __webpack_public_path__ + "site/img/17.70ece8f9.jpg";